<template>
  <div class="custom-date-picker">
    <v-menu
      ref="menu1"
      v-model="menu1"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateFormatted"
          :placeholder="label || 'DD/MM/AAAA'"
          @blur="date = parseDate(dateFormatted)"
          v-bind="attrs"
          v-on="on"
          readonly
          outlined
          dense
          hide-details
          prepend-inner-icon="mdi-calendar"
          :append-icon="date ? 'mdi-close' : ''"
          @click:append="clearDate"
          @click="menu1 = true"
          class="field-input-component cursor-pointer"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        locale="pt-br"
        @input="selectDate"
        :type="type || 'date'"
        color="orange"
        no-title
        scrollable
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "InputDate",
  props: ["label", "texto", "Dinicial", "type", "value"],
  data() {
    return {
      date: null,
      dateFormatted: "",
      menu1: false,
    };
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(val);
      this.$emit('dateValue', val);
      this.$emit('input', val);
    },
    value: {
      immediate: true,
      handler(val) {
        this.date = val;
      }
    }
  },
  methods: {
    selectDate() {
      this.menu1 = false;
    },
    clearDate() {
      this.date = null;
      this.dateFormatted = "";
      this.$emit('dateValue', null);
      this.$emit('input', null);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.type == "month") {
        return `${month}/${year}`;
      }
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.custom-date-picker >>> .v-input__control .v-input__slot {
  background-color: #f8fafc !important;
  border-radius: 6px !important;
}
.custom-date-picker >>> .v-input__control .v-input__slot fieldset {
  border-color: #e2e8f0 !important;
  border-width: 1px !important;
}
.custom-date-picker >>> .v-input__control .v-input__slot:hover fieldset {
  border-color: #f37021 !important;
}
.custom-date-picker >>> input {
  font-size: 13px !important;
  color: #334155 !important;
  font-weight: 600 !important;
}
.custom-date-picker >>> .v-icon {
  font-size: 18px !important;
}
</style>
